
import { useState, useEffect } from "react";
import { isIOS } from "react-device-detect";
import { get_app_url } from "../../server/requests";

import './Mobile.scss'
import { translateWord } from "../Util/util";
import { useRouter } from "../../hooks/router";

const Mobile = ({ configs }) => {

    const router = useRouter()
    const logo = configs.logo

    console.log(configs, 'configs')

    const data_market_url = (type) => {

        get_app_url({}, data => {

            let _url_market = ''

            if (type == 'android') _url_market = data.play_market_url

            else _url_market = data.app_store_url

            window.location.href = _url_market

        }, err => console.log('Page is not found'))

    }

    const changeUrlAndroid = () => data_market_url('android')

    const changeUrlIOS = () => data_market_url('ios')

    const cancel = () => {
        // let url = configs?.web_page.replace('{{lang}}',configs?.language.iso_code)
        router.push('/settings?a=account')
        // window.location.href = url
    }

    return (
        <div className="main-device">
            <div className="device">
                <div className="app-icon-mobile">
                    <img src={logo} alt="" />
                </div>
                <div className="support">
                    <p>{translateWord(`${configs?.app_name} dose not support this device, please download the app`)}</p>
                </div>
                <div className="app_btn">
                    {isIOS ?
                        <button className="download_btn" onClick={changeUrlIOS}>
                            <svg width="43" height="53" viewBox="0 0 43 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M36.2465 29.8166C34.7593 22.1743 41.3302 18.0919 41.8098 17.806C40.8922 16.5604 39.7528 15.499 38.4501 14.6764C34.5224 12.1992 29.7384 11.9682 26.8925 13.2328L26.8069 13.2703C25.4332 13.8773 23.9502 14.1906 22.4511 14.1906C20.952 14.1906 19.469 13.8773 18.0952 13.2703L18.0096 13.2328C15.1552 11.9653 10.3797 12.1963 6.45202 14.6764C2.52433 17.1564 -1.29202 22.7373 0.643276 33.4429C2.57858 44.1485 9.64043 50.6619 9.64043 50.6619C10.7312 51.5242 12.0329 52.0709 13.4068 52.2438C14.7806 52.4167 16.1751 52.2092 17.4416 51.6435C20.2161 50.4193 21.4806 50.1999 22.0372 50.2201C22.3226 50.2201 22.5881 50.2201 22.865 50.2201C23.4358 50.2057 24.6861 50.4193 27.4606 51.6435C28.727 52.2092 30.1215 52.4167 31.4954 52.2438C32.8692 52.0709 34.1709 51.5242 35.2617 50.6619C35.2617 50.6619 40.2085 46.103 42.9687 38.3337C40.5938 37.2366 37.217 34.82 36.2465 29.8166Z" fill="#191919" />
                                <path d="M21.2006 12.8316C21.2006 12.8316 19.959 2.14917 31.8476 0.243652L31.7991 1.68723C31.704 4.54153 30.5691 7.2595 28.6127 9.31877C26.6564 11.378 24.0166 12.6333 21.2006 12.8432V12.8316Z" fill="#191919" />
                            </svg>
                            <div className="btn-text">
                                <span>{translateWord('Download on the', 'Download on the')}</span>
                                <span>App Store</span>
                            </div>
                        </button>
                        :
                        <button className="download_btn" onClick={changeUrlAndroid}>
                            <svg width="46" height="52" viewBox="0 0 46 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M34.6768 17.4817L26.4752 25.6769L2.39941 1.01484C3.02669 0.628599 3.74671 0.421616 4.48212 0.416128C5.21752 0.41064 5.94051 0.606857 6.57341 0.983695L34.6768 17.4817Z" fill="#00F076" />
                                <path d="M34.8795 34.3114L6.57349 50.9283C5.80508 51.3828 4.90977 51.5712 4.02473 51.4648C3.13968 51.3585 2.31371 50.9631 1.67334 50.3393L26.4752 25.6772L34.8795 34.3114Z" fill="#F73448" />
                                <path d="M43.0585 29.5114L34.9413 34.2858L34.8794 34.3226L26.4751 25.6771L34.6767 17.4819L34.7415 17.5187L43.0585 22.3923C43.6777 22.7545 44.1916 23.2738 44.5488 23.8985C44.906 24.5231 45.094 25.2312 45.094 25.9518C45.094 26.6725 44.906 27.3805 44.5488 28.0051C44.1916 28.6298 43.6777 29.1492 43.0585 29.5114Z" fill="#FFCA00" />
                                <path d="M1.67348 50.3392L1.62282 50.2911C1.23873 49.9099 0.934481 49.4552 0.728058 48.9537C0.521635 48.4523 0.417224 47.9142 0.420997 47.3715V4.55204C0.417234 3.85452 0.591498 3.1677 0.927099 2.55734C1.2627 1.94699 1.7484 1.43353 2.33771 1.06611L2.39963 1.0293L26.4754 25.6913L1.67348 50.3392Z" fill="#00D2FF" />
                            </svg>
                            <div className="pargaraph">
                                <span>{translateWord('GET IT ON', 'GET IT ON')}</span>
                                <span>Google Play</span>
                            </div>
                        </button>
                    }
                    <button className="cancel_btn" onClick={cancel}>
                        {translateWord('Cancel', 'Cancel')}
                    </button>
                </div>
            </div>
        </div>
    )
}
export default Mobile;